import { render, staticRenderFns } from "./authentication-dialog.vue?vue&type=template&id=5ee4bf21&scoped=true"
import script from "./authentication-dialog.vue?vue&type=script&lang=js"
export * from "./authentication-dialog.vue?vue&type=script&lang=js"
import style0 from "./authentication-dialog.vue?vue&type=style&index=0&id=5ee4bf21&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee4bf21",
  null
  
)

export default component.exports